<table mat-table class="mat-table-selection" [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
  (matSortChange)="sortChanged($event)" [matSortDirection]="sortDirection">

  <ng-container matColumnDef="noRecord">
    <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
      {{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}
    </td>
  </ng-container>

  <ng-container matColumnDef="scope">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{'scope'| translate:['tmc-yard.entity.vehicle.scope', translationService.language]}}</th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle">
      <app-transport-scope-icon [scope]="vehicle.scope"></app-transport-scope-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="carrier">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{'carrier'| translate:['tmc-yard.entity.vehicle.carrier', translationService.language]}}</th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle"> {{vehicle.carrier}} </td>
  </ng-container>

  <ng-container matColumnDef="identifier">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{'numberplate'| translate:['tmc-yard.entity.vehicle.numberplate',
      translationService.language]}}
    </th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle"> {{vehicle.identifier}} </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{'name'| translate:['tmc-yard.entity.vehicle.name', translationService.language]}}</th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle"> {{vehicle.name}} </td>
  </ng-container>

  <ng-container matColumnDef="currentStation">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{'currentStation'| translate:['tmc-yard.entity.vehicle.current-station',
      translationService.language]}}
    </th>
    <td mat-cell class="text-selection" [ngClass]="{'selected': selectedListEntry == vehicle}"
      *matCellDef="let vehicle"> {{vehicle.currentStation}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

  <tr mat-row *matRowDef="let vehicle; columns: columnsToDisplay" [attr.data-vehicle-id]="vehicle.id"
    [ngClass]="getRowStyles(vehicle)" (click)="toggleSelection(vehicle)"></tr>

  <tr [class.hide]="dataSource.data.length > 0" mat-footer-row *matFooterRowDef="['noRecord']"></tr>
</table>
